export const CROSS_FLOW = 'CROSS_FLOW';
export const PROJECT_CREATE = 'PROJECT_CREATE';
export const EXISTING_PROJECT = 'EXISTING_PROJECT';

export type Source = typeof CROSS_FLOW | typeof PROJECT_CREATE | typeof EXISTING_PROJECT;
